module.exports = __webpack_public_path__ + "img/attach-file-gray.3b49fc3f.svg";